import React from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { Store } from '../store';
import List from './List';
import { Sheet } from '@src/mobile/components/ModalBox';

const ReplyModal = ({ allowComment }) => {
    const store = Store.useContainer();
    const { states, changeStates } = store;
    const { showReplyModal } = states;

    const handleReplyModalClose = () => {
        changeStates({ showReplyModal: false });
    };

    return (
        <Sheet show={showReplyModal} top={80} onClose={handleReplyModalClose}>
            <List onClose={handleReplyModalClose} allowComment={allowComment} />
        </Sheet>
    );
};

ReplyModal.propTypes = {
    allowComment: PropTypes.bool,
};

export default errorBoundary(ReplyModal);
